const PropTypes = require('prop-types');
// @vendors
const React = require('react');

// @ utils
const { formatText } = require('core/i18n').i18n;

// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @ local
const ResultsRow = require('./plansResultsRow');

class BrokerAdvancedSearchPlansResultsTable extends React.Component {
    constructor(props) {
        super(props);
        this.handleProductSelect = this.handleProductSelect.bind(this);
    }
    compareButton(checkedList) {
        const compareLabel = formatText(`broker-searchResultsCompareLabel`);
        const isCompareDisabled = (checkedList.size < 2);
        return (
            <OKTableRow className="broker-search-results__table-footer-row">
                <OKTableCell className="broker-search-results__table-footer-cell">
                    <OKButton
                        modifier="secondary"
                        disabled={isCompareDisabled}
                    >
                        {compareLabel}
                    </OKButton>
                </OKTableCell>
            </OKTableRow>
        );
    }

    tableHeaders() {
        const { fromPlansTransfer } = this.props;
        const PREFIX = 'broker-searchResults';
        const nameLabel = formatText(`${PREFIX}NameLabel`);
        const categoryLabel = formatText(`${PREFIX}CategoryLabel`);
        const ratingLabel = formatText(`${PREFIX}PlansRatingLabel`).split(' ');
        const riskLabel = formatText(`${PREFIX}PlansRiskLabel`);
        const earningsLabel = formatText(`${PREFIX}EarningsLabel`);
        const ytdLabel = formatText(`${PREFIX}YtdLabel`);
        const aYearLabel = formatText(`${PREFIX}AYearLabel`);
        const threeYearsLabel = formatText(`${PREFIX}ThreeYearsLabel`);
        const fiveYearsLabel = formatText(`${PREFIX}FiveYearsLabel`);
        const downloadPDF = formatText(`${PREFIX}DownloadPDF`);

        return (
            <OKTableRow asHeader={true} className="broker-search-results__table-header">
                <OKTableCell
                    asHeader={true}
                    className="broker-search-results__table-header-cell--check broker-search-results__table-first-column"
                />
                <OKTableCell
                    asHeader={true}
                    className="broker-search-results__table-first-column"
                    width="20%"
                >
                    {nameLabel}
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    width="10%"
                >
                    {categoryLabel}
                </OKTableCell>
                <OKTableCell
                    alignment="center"
                    asHeader={true}
                    width="10%"
                >
                    <span>{ratingLabel[0]}</span>
                    <br/>
                    <span>{ratingLabel[1]}</span>
                </OKTableCell>
                <OKTableCell
                    alignment="center"
                    asHeader={true}
                    width="8%"
                >
                    {riskLabel}
                    <OKTooltip
                        content="broker-searchResultsDDFPTooltip"
                        offset={[0,-15]}
                    />
                </OKTableCell>
                <OKTableCell
                    alignment="center"
                    asHeader={true}
                    width="5%"
                >
                    <span className="broker-search-results__table-header-earnings-title">
                        {earningsLabel}
                        <hr className="broker-search-results__earnings-divider" />
                    </span>
                    <span className="broker-search-results__table-cell--ytdlabel">
                        {ytdLabel}
                    </span>
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    asHeader={true}
                    width="5%"
                >
                    {aYearLabel}
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    asHeader={true}
                    width="5%"
                >
                    {threeYearsLabel}
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    asHeader={true}
                    className="broker-search-results__table-header-cell--plan-five-year"
                    width="5%"
                >
                    {fiveYearsLabel}
                </OKTableCell>
                <OKTableCell
                    alignment="center"
                    asHeader={true}
                    width="5%"
                >
                    {downloadPDF}
                </OKTableCell>
                {fromPlansTransfer? 
                    null : 
                    (<OKTableCell
                        asHeader={true}
                        className="broker-search-results__table-header-cell--plan-action" 
                        width="8%"
                    />)
                }
            </OKTableRow>

        );
    }

    handleProductSelect(product) {
        this.props.onHandleProductSelect(product);
    }

    radioTableRows(results) {
        const tableRows = results.map((result) => {
            const secId = result.get('secId');
            return (
                <ResultsRow
                    fromPlansTransfer={this.props.fromPlansTransfer}
                    key={secId}
                    item={result}
                    onHandleProductSelect={this.handleProductSelect}
                    isActive={this.props.selectedNewPlan === secId}
                />
            )
        });
        return tableRows;
    }

    tableRows(results, checkedList) {
        const tableRows = results.map((result,index) => {
            const secId = result.get('secId');
            return (
                <ResultsRow
                    isActive={checkedList.includes(secId)}
                    key={secId}
                    item={result}
                    onHandleProductSelect={this.handleProductSelect}
                    checkedList={checkedList}
                    saveCheckedList={this.props.saveCheckedList}
                    onWatchlistClick={this.props.onHandleWatchlistAdd}
                    deleteProductFromList={this.props.deleteProductFromList}
                    rowIndex={index}      
                    watchlistEnabled={this.props.watchlistEnabled}
                />
            );
        });

        return tableRows;
    }

    render() {
        const { results, checkedList} = this.props;

        const tableHeaders = this.tableHeaders();
        const tableRows = this.props.fromPlansTransfer ? this.radioTableRows(results) : this.tableRows(results, checkedList);
        // Botón comentado hasta que se adicione la funcionalidad.
        //const compareButton = this.compareButton(checkedList);

        /**
         * @horizontal-scroll
         *
         * The result table has a container with an horizontal scroll and the
         * inner content is set to a fix width according to its size in
         * desktop.
         */

        return (
            <div className="broker-search-results__table-wrapper" style={{ overflowX: 'auto' }}>
                <OKTable className="broker-search-results__table">
                    <thead>
                        {tableHeaders}
                    </thead>
                    <tbody>
                        {tableRows}
                    </tbody>
                    <tfoot className="broker-search-results__table-footer">
                        { /*compareButton*/ }
                    </tfoot>
                </OKTable>
            </div>
        );
    }
}

BrokerAdvancedSearchPlansResultsTable.propTypes = {
    fromPlansTransfer: PropTypes.bool,
    selectedNewPlan: PropTypes.string,
    results: PropTypes.object,
    searchState: PropTypes.object,
    checkedList: PropTypes.object,
    saveCheckedList: PropTypes.func,
    onHandleWatchlistAdd: PropTypes.func,
    deleteProductFromList: PropTypes.func,
    onHandleProductSelect: PropTypes.func,
    plansToFilter: PropTypes.object,
    watchlistEnabled: PropTypes.bool
}

module.exports = BrokerAdvancedSearchPlansResultsTable;
